import { useQuery } from '@tanstack/react-query';
import { cityApi } from '../regionApi';
import { QueryKey } from '@shared/config';
import { PaginateType } from '@shared/types';

export const useGetCities = (enabled = true) => {
  return useQuery({
    queryKey: [QueryKey.GET_REGIONS],
    queryFn: () =>
      cityApi.getCities({
        paginate: PaginateType.NONE,
        filter: {},
      }),
    retry: false,
    enabled,
  });
};
